import {
	Backdrop,
	createStyles,
	Fade,
	makeStyles,
	Modal,
	Theme,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import FalhaPagamento from "../../../assets/kinologyIcons/svg/falha_pagamento.svg";
import { FinancialActions } from "../../../store/ducks/financial";
import { AppActions } from "../../../store/ducks/app";
import { DashBoardActions } from "../../../store/ducks/dashboard";
import {ReactComponent as Close} from "../../../assets/kinologyIcons/svg/close.svg";
import {ReactComponent as Whatsapp} from "../../../assets/kinologyIcons/svg/whatsapp_blue.svg";
import { TextsProps } from "../../../database/txt.interface";
import { removeItemStorage } from "../../../utils/base_async_storage";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: "0",
			boxShadow: theme.shadows[5],
		},
	})
);

interface FaturaPendenteState {
	titulo: string;
	subtitulo: string;
	isVisible: boolean;
}

const WHATSAPP_NUMBER = "556133479291";


const ModalFaturaPendente: React.FC = () => {
	const dispatch = useDispatch();
	const classes = useStyles();

	const [state, setState] = useState<FaturaPendenteState>({
		titulo: "",
		subtitulo: "",
		isVisible: false,
	});
	const current_language:TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);
	const config_servicos = useSelector(
		(state: any) => state.configs.config_servicos
	);
	const modal_pagamento_nao_identificado = useSelector(
		(state: any) => state.financial.modal_fatura_pendente
	);
	const pending_days = useSelector(
		(state: any) => state.financial.number_pending_days
	);
	const current_page: string = useSelector(
		(state: any) => state.dashboard.current_page
	);
	

		const RenderSubtitle:any = {
			fatura_pendente:<>
												<SubtitleModal bold={false} >
													{current_language?.fatura_atrasada} 
												</SubtitleModal> 
												<br />
												<SubtitleModal bold>{current_language?.efetuar_pagamento}</SubtitleModal>
											</>,
			negativacao_serasa:<>
													<SubtitleModal bold={false}>
														{current_language?.negativacao_pendencia}
													</SubtitleModal>
													<SubtitleModal  bold>
														{' '+ current_language?.voce_pode}
														<SubtitleModal bold={false}>
															{' '+ current_language?.encontrar_solucao}
														</SubtitleModal>
														
													</SubtitleModal>
												</>,
			efetue_pagamento: <>
													<SubtitleModal bold={false}>
														{current_language?.debito_nome}
													</SubtitleModal>
													<br />
													<SubtitleModal bold >
														{current_language?.efetuar_pagamento_2} 
														<SubtitleModal  bold={false}>
															{' '+current_language?.contato_solucao}
														</SubtitleModal> 
													</SubtitleModal>
												</>
		}

	let typeClientLocalStorage = localStorage.getItem('TypeClientFinancial')
	const INADIMPLENCIA_LIMITES = {
		ALERTA_INICIAL: 2,
		ALERTA_INTERMEDIARIO: 8,
		ALERTA_FINAL: 30,
	};
	
	const atualizarMensagemInadimplencia = (dias: number) => {
		
		if(dias >= 8){
			dispatch(AppActions.set_block_side_menu(true))
		}
		
		if (
			dias >= INADIMPLENCIA_LIMITES.ALERTA_INTERMEDIARIO 
			&& dias < INADIMPLENCIA_LIMITES.ALERTA_FINAL
		) {
			setState(prev => ({
				...prev,
				isVisible: true,
				titulo: current_language?.evitar_negativacao_serasa,
				subtitulo: 'negativacao_serasa'
			}));
			dispatch(FinancialActions.set_modal_fatura_pendente(true));
		} 
		if (
			dias >= INADIMPLENCIA_LIMITES.ALERTA_FINAL
		) {
			setState(prev => ({
				...prev,
				isVisible: true,
				titulo: current_language?.efetuar_pagamento_2,
				subtitulo:'efetue_pagamento'
			}));
			dispatch(FinancialActions.set_modal_fatura_pendente(true));
		}
		
	};

	useEffect(() => {
		if(pending_days >= 8 && current_page != "pagamentos_external"){
			atualizarMensagemInadimplencia(pending_days);
		}
	}, [pending_days, current_page]);

	const handleClose = () => {
		dispatch(FinancialActions.set_modal_fatura_pendente(false));
	};

	const handlePagarFatura = () => {
		dispatch(FinancialActions.set_modal_fatura_pendente(false));
	
		if(typeClientLocalStorage == 'bank_slip_pix'){
			dispatch(dispatch(FinancialActions.set_modal_escolha_pagamento(true)))
		}else{
			dispatch(DashBoardActions.set_current_page("adicionar_pagamento"));
		}
	};

	const handleEntrarContato = () => {
		window.open(`https://wa.me/${WHATSAPP_NUMBER}`, "_blank");
	};

	if (!state.isVisible) return null;

	return (
		<Modal
			aria-labelledby="transition-modal-title"
			aria-describedby="transition-modal-description"
			className={classes.modal}
			open={modal_pagamento_nao_identificado}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{ timeout: 500 }}
		>
			<Fade in={modal_pagamento_nao_identificado}>
				<ModalContainer>
					<ModalContent>
						<HeaderContainer onClick={handleClose}  style={{display: state.titulo === 'Fatura pendente' ? 'flex' : 'none'}}>
								<Close width={18} height={18} style={{right:15, top:20,  position: 'absolute'}}/>
						</HeaderContainer>
						<IconContainer>
							<ModalIcon src={FalhaPagamento} alt="Falha no pagamento" />
						</IconContainer>
						<Title>{state.titulo}</Title>
						{RenderSubtitle[state.subtitulo]}
						<ButtonContainer>
							<Button onClick={()=>{
									handleEntrarContato(), 	
									removeItemStorage('last_invoice_pending'),
									setState(({
										titulo: "",
										subtitulo: "",
										isVisible: false,
									}));
								}}
							>
								<Whatsapp style={{marginRight:12}} />
								{current_language?.entrar_em_contato}
							</Button>
							<Button primary onClick={()=>{
								dispatch(DashBoardActions.set_current_page("pagamentos_external"))
								dispatch(FinancialActions.set_modal_fatura_pendente(false))
								removeItemStorage('last_invoice_pending')
								setState(({
									titulo: "",
									subtitulo: "",
									isVisible: false,
								}));
							
							}}>
								{current_language?.pagar_fatura}
							</Button>
						</ButtonContainer>
					</ModalContent>
				</ModalContainer>
			</Fade>
		</Modal>
	);
};

// Styled Components
const ModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: fixed;
	width: 160vw;
	height: 100vh;
`;
const SubtitleModal = styled.div<{bold:boolean}>`
	color: #000E4B;
	display: inline;
	font-family: 'NotoSans-Regular';
	font-weight: ${({bold})=> bold ? '700' : '400'};
`;
const ModalContent = styled.div`
	background: white;
	padding: 20px;

	position: relative;
	border-radius: 0.75rem;
	width: 587px;
	text-align: center;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

const HeaderContainer = styled.div<{visible?: boolean}>`
	width: 100%;
	display: flex;
	justify-content: flex-end;
`;

const CloseButton = styled.button`
	background: none;
	border: none;
	font-size: 16px;
	cursor: pointer;
	padding: 8px;
	
	&:hover {
		opacity: 0.8;
	}
`;

const ButtonContainer = styled.div`
	display: flex;
	margin-top: 10px;
	justify-content: space-between;
	gap: 10px;
`;

const InfoText = styled.p`
	font-size: 14px;
	color: #333;
	margin: 1.5rem 0;
	line-height: 1.5;
`;

const IconContainer = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;
	margin: 16px 0;
`;

const ModalIcon = styled.img`
	width: 4rem;
	height: 4rem;
`;

const Title = styled.h2`
	font-size: 18px;
	color: #002060;
	margin: 0 0 8px;
	font-weight: 600;
`;

interface ButtonProps {
	primary?: boolean;
}

const Button = styled.button<ButtonProps>`
	width: 100%;
	display: flex;
	padding: 12px;
	font-size: 16px;
	font-weight: 600;
	align-items: center;
	justify-content: center;
	font-family: 'Kanit-Regular';
	background-color: ${({ primary }) => (primary ? "#009973" : "white")};
	color: ${({ primary }) => (primary ? "white" : "#000E4B")};
	border-radius: 0.75rem;
	margin-bottom: 8px;
	cursor: pointer;
	transition: all 0.2s ease-in-out;

	&:hover {
		background-color: ${({ primary }) => (primary ? "#008863" : "#FFFFFF")};
	}

	&:active {
		transform: scale(0.98);
	}
`;

export default ModalFaturaPendente;
